import type { ComicPanel } from './comicTypes'

export function pageHasGeneratableScript(panels: ComicPanel[]): boolean {
  return panels.some((p) => p.script.trim().length > 0)
}
